module.exports = __webpack_public_path__ + "f2950e1ee7a38d01db2205728577cd49.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/empty-state/data-table.png
// module id = 512
// module chunks = 0